import React, { Component } from "react";
 

class Informations extends Component {
  render() {
    return (
      <div>
        <h2>Informations</h2>
      </div>
    );
  }
}
 
export default Informations;